<form
  class="captcha flex flex-col"
  (clickOutside)="closeCaptchaOverlay.emit()"
  [formGroup]="captchaForm"
  (ngSubmit)="submitVerifyCaptcha()"
>
  <div
    class="captcha-image flex items-center justify-center"
    [innerHTML]="captcha() | safeHtml"
  ></div>

  <div class="form-field">
    <input
      required
      #captchaInput
      type="text"
      name="captcha"
      [formControl]="captchaControl"
      placeholder="Enter captcha..."
    />
  </div>
  <button
    type="submit"
    class="drop-join button button--style-yellow h-32 rounded-4 padding-x-12"
  >
    Verify
  </button>
</form>
